// PST-570 — GNB self-fetch 진행 중(gnbLoading) LNB nav 행에 표시하는 스켈레톤.
// 실제 nav(아이콘+라벨)를 흉내내 상단 폭 전체에 space-between 으로 분산 → default→region 스왑 flash 없이 로딩 표현.

import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { globalVariables } from '../../../shared/designSystem/constants';

// 실제 nav 라벨 폭 편차를 흉내내 layout-shift 를 최소화(대략치). 개수는 실제 GNB 항목 수(≈10)에 맞춘다.
const LABEL_WIDTHS = [56, 68, 48, 76, 44, 60, 52, 72, 56, 40];

export default function LocalNavSkeleton() {
  return (
    <Container aria-hidden>
      {LABEL_WIDTHS.map((width, index) => (
        <Item key={index}>
          <IconDot />
          <LabelBar style={{ width }} />
        </Item>
      ))}
    </Container>
  );
}

const shimmer = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
`;

// 실제 DefaultLocalNavItems 와 동일하게 상단 폭 전체에 space-between 으로 분산.
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`;

const Item = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const IconDot = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${globalVariables.gray_200};
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

const LabelBar = styled.span`
  height: 16px;
  border-radius: 4px;
  background-color: ${globalVariables.gray_200};
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;
